import RedemptionsController from './redemptions.controller.js';
import RedemptionEditController from './redemption.edit.controller.js';
import redemptionsTpl from './redemptions.html';
import redemtpionsEditTpl from './redemptions.edit.html';

export default function redemptionsRouter($stateProvider) {
  $stateProvider
    .state('app.redemptions', {
      url: '/redemptions',
      templateUrl: redemptionsTpl,
      controller: RedemptionsController,
      controllerAs: 'redemptions',
      data: {
        authorizedPermissions: ['REDEMPTION_READ'],
      },
    })
    .state('app.redemptions.edit', {
      url: '/:redemptionId',
      templateUrl: redemtpionsEditTpl,
      controller: RedemptionEditController,
      controllerAs: 'redemptionEdit',
      data: {
        authorizedPermissions: ['REDEMPTION_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/redemptions/redemptions.router.js